export const hasError = state => state.groups.create.hasError
export const isPending = state => state.groups.create.isPending
